<div class="modal1Main leaguRegPop" *ngIf="result">
  <form [formGroup]="joinForm" (ngSubmit)="onSubmit()">
    <div class="modalHeader">
      <span class="title">
        League Registration
      </span>
      <button class="closepop float-right" mat-dialog-close><i class="zmdi zmdi-close"></i></button>
    </div>
    <div class="fantasyGameHead">
      <div class="row">
        <div class="col s12 m12 l12 x12">
          <h3 class="pT0"><img src="{{assetURL}}/assets/default/images/{{ result.league_type }}{{darkMode_ext}}.svg?v=2.7.5" alt="">
            {{ result.name }}</h3>
        </div> 
      </div>
    </div>
    
    <div class="preDraftRankDiv" *ngIf="drafttype_id < 4">
      <div class="league-draft">
      <span> Pre Draft Rankings : </span>
      <mat-form-field  >
        <mat-select *ngIf="result.ranking_set"  formControlName="assigned_rank" >
          <mat-option *ngFor="let rec of result.ranking_set" value="{{rec.value}}">
            {{rec.text}}
          </mat-option> 
        </mat-select>
      </mat-form-field>
      </div>
    </div>
    <div class="league-draft" *ngIf="drafttype_id < 4 && result?.sms_flag==true">
      <div class="league-rankings">
        <span>Send text alert when draft is starting: </span> 
      </div>
      <div class="league-draft-projected">
        <div class="button-cover" (click)="smsToggle()">
          <div class="button r" id="button-1">
            <input type="checkbox" class="checkbox" formControlName="msg_send">
            <div class="knobs"></div>
            <div class="layer"></div>
          </div>
        </div>
      </div>
    </div>
    <div class="sendSmsDiv" *ngIf="drafttype_id < 4 && show_phone && result?.sms_flag==true" [@fadeInOut]>
      <div class="row">
        <div class="col s12 m12 l2 xl2 disFlex">
          <mat-form-field>
            <input matInput formControlName="phone_number" (keypress)="keyPress($event)">
          </mat-form-field> 
        </div>
      </div>
      <span style="font-size:14px;">Phone number is collected for draft notification purposes only.<br>Messages and data rates may apply. Messages frequency may vary. Reply HELP for help. STOP for unsubscribe. View <a href="{{phpUrl}}/pages/privacypolicy" class="link" target="_blank">Privacy Policy</a> &amp; <a href="{{phpUrl}}/pages/termsofuse" class="link" target="_blank">Terms Of Use</a>.<br></span>
    </div>
    <div class="league-draft" *ngIf="result?.ticket?.label">
      <div class="league-rankings">
        <span>{{result?.ticket?.label}}: </span>
      </div>
      <div class="league-draft-projected">
        <div class="button-cover" (click)="ticketToggle()">
          <div class="button r" id="button-2">
            <input type="checkbox" class="checkbox" formControlName="use_ticket">
            <div class="knobs"></div>
            <div class="layer"></div>
          </div>
        </div>
        </div>
        </div>
        <div class="preDraftRankDiv" *ngIf="result.multi_entry && drafttype_id < 4">
        <span> Join the next: </span> 
        <span class="xDraftJoin">
          <mat-form-field>
            <mat-select formControlName="counter" (ngModelChange)="counterChange()">
              <mat-option *ngFor="let rec of selectCounter" value="{{rec}}">
                {{rec}}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </span>
        <span>Drafts </span>
    </div>
  
    <div class="draftSpeed">
      <mat-button-toggle-group *ngIf="result.draft_speed_set && result.draft_speed_set.length > 1" name="second_per_pick"  formControlName="second_per_pick" aria-label="Font Style">
        <mat-button-toggle *ngFor="let speed of result.draft_speed_set" value="{{speed.value}}" [checked]="speed.active == 1">{{speed.name}}</mat-button-toggle>
      </mat-button-toggle-group> 
    </div> 

    <div class="">
      <div class="league-balance-block">
        <span>Available Balance: <div class="green-number"><strong> {{result.balance_text}}</strong></div></span>
      </div>
      <div class="league-balance-block">
        <span>Your account will be charged: 
          <ng-container *ngIf="!use_ticket; else useTicket">
            <div class="lb-number"><strong> {{result.entry_fee}}</strong></div>
          </ng-container>
          <ng-template #useTicket>
            1 Ticket
          </ng-template>
        </span>
      </div>
    </div>
      
    <div class="text-center leaguRegfoot">
        <button mat-raised-button color="primary" [disabled]="submitted" class="joinDraftBtn" >Join</button>
        <button mat-raised-button color="primary" class="cancelBtn" mat-dialog-close>Cancel</button> 
    </div>
    <div class="league-balance-block" style="font-size: 14px;">*To receive a notification when your draft is starting, please <a class="link" href="javascript:void(0);" (click)="openAppPopup();">download our app</a> and allow notifications</div>
    </form>
  </div>
  <ng-template #mobileApp>
    <div class="mobileApp" [ngClass]="{'active':visiblemobileApp}">
      <div class="smart-body">
        <h2>It's Easier With The App!</h2>
        <div class="smart-cardContainer">
          <a href="http://apps.apple.com/us/app/drafters-fantasy-sports/id1273975920/" target="_blank" class="smartbanner-icon">
            <img src="{{assetURL}}/assets/default/new/images/appstore_2.png" alt="">
          </a>
          <a href="https://app2.drafters.info/uC18" target="_blank" class="smartbanner-icon">
              <img src="{{assetURL}}/assets/default/new/images/googlestore_2.png" alt="">
          </a>
        </div>
      </div>
    </div>
    </ng-template>